import { computed } from 'vue'
import { useConfigStore } from '@/stores/config'
import { useTranslaterStore } from '@/stores/translater'

/**
 * Изменение document.title
 *
 * @param { Array } metaBreadcrumbs - meta.breadcrumbs из роутера
 * @returns { null }
 */
export default function setPageTitle(metaBreadcrumbs) {

    const translaterStore   = useTranslaterStore()
    const configStore       = useConfigStore()
    const getTranslate      = computed(() => translaterStore.getTranslate)
    const appName           = configStore.appName
    const metaName          = metaBreadcrumbs ? metaBreadcrumbs[metaBreadcrumbs.length - 1]?.name : false

    document.title = (metaName ? getTranslate.value[metaName] + ' - ' : '') + appName
}
